import {type RunsLinePlotConfig} from './types';

/** Preserve saved selection semantics without passing the configuration to Graph. */
export function getGraphSelection(config: RunsLinePlotConfig): {
  metrics?: string[];
  hasExpressions: boolean;
  regexDataKey: string | null;
} {
  const metrics = config.metrics;
  const regexDataKey =
    config.useMetricRegex &&
    config.metricRegex &&
    metrics != null &&
    metrics.length > 0
      ? [config.metricRegex, ...metrics].join('\0')
      : null;
  return {
    metrics,
    hasExpressions: (config.expressions?.length ?? 0) > 0,
    regexDataKey,
  };
}
